const Core = require('../core');

const ENTRY_SOURCE_SESSION_FLAG = 'entry_source_set';
const ENTRY_SOURCE = { PARTNER_WIDGET: 'partner_widget', DIRECT: 'direct' };

function _entrySourceLocked() {
    try {
        return sessionStorage.getItem(ENTRY_SOURCE_SESSION_FLAG) === '1';
    } catch (_e) {
        return false;
    }
}

function _lockEntrySource() {
    try {
        sessionStorage.setItem(ENTRY_SOURCE_SESSION_FLAG, '1');
    } catch (_e) { /* noop */ }
}

function _register(entrySource) {
    Core.registerSuperProperties({ entry_source: entrySource });
}

function registerDirectEntrySource() {
    if (_entrySourceLocked()) {
        return;
    }

    _register(ENTRY_SOURCE.DIRECT);
    _lockEntrySource();
}

function registerResultsEntrySource(cameFromPartnerWidget) {
    if (_entrySourceLocked()) {
        return;
    }

    _register(cameFromPartnerWidget ? ENTRY_SOURCE.PARTNER_WIDGET : ENTRY_SOURCE.DIRECT);
    _lockEntrySource();
}

// Override-safe soft default for sessions that don't land on search/results.
// Sets entry_source=direct without locking, so a later explicit page
// classification (search/results) can still overwrite it.
function registerDefaultEntrySource() {
    if (_entrySourceLocked()) {
        return;
    }

    _register(ENTRY_SOURCE.DIRECT);
}

module.exports = {
    ENTRY_SOURCE,
    registerDirectEntrySource,
    registerResultsEntrySource,
    registerDefaultEntrySource
};
